import { render, staticRenderFns } from "./PagesHome.vue?vue&type=template&id=1d6c8ffe&"
import script from "./PagesHome.vue?vue&type=script&lang=js&"
export * from "./PagesHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports